import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserLogin } from '../models/userlogin';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private router: Router) {
    const localStringUser = localStorage.getItem('currentUser');
    let localUser: UserLogin | null = null;

    if (localStringUser) {
      localUser = <UserLogin>JSON.parse(localStringUser);
      this.UserValue = localUser;
      this.User.next(localUser);
    }
  }
  User: BehaviorSubject<UserLogin | null> = new BehaviorSubject<UserLogin | null>(null);
  UserValue!: UserLogin;


  Login(code: string, nonce: string): Observable<UserLogin> {
    const userData = {
      Code: code,
      Nonce: nonce,
    };

    const request = this.http.post<UserLogin>(`${environment.api}/login`, userData)
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user) {
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.UserValue = user;
          this.User.next(user);
        }
        return user;
      }));

    return request;
  }

  logout() {
    // Clear LS ad Behaviour Subject
    this.User.next(null);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('state');

    window.open(environment.LogoutURL, "_blank", "width=640,height=480,top=300,left=680")
    this.router.navigate(["/login"]);
  }



}
